// Ordonnancement par la carte (LOT 7c §5) — module 100 % pur. Position =
// rang dans ORDRE_CARTE (positions stables), AUCUN tri dynamique/alphabétique.
// Un nom inconnu de la carte (ex. ajout futur avant mise à jour de l'ordre)
// passe APRÈS les connus, dans son ordre d'origine (tri stable).
export function ordonnerParCarte<T extends { nom: string }>(
  items: readonly T[],
  ordre: readonly string[],
): T[] {
  const rang = new Map(ordre.map((nom, i) => [nom, i]));
  return [...items].sort(
    (a, b) =>
      (rang.get(a.nom) ?? ordre.length) - (rang.get(b.nom) ?? ordre.length),
  );
}
